export function getAxiosParams(){
    return {
        baseURL: "https://enjoy-the-street.de/api/V1/",
        headers: {
          "x-api-key": "PPdH1WKwRa2BFGG57g16yxyqqevJ2kfJZgeQ2OcIO85iyFbvLZm7mIoAMLaCRdbGkdkaRkIucGAAbAULq6IACUZfrZF82HCaIKbqUJIWf2nfx5OLZk9r5YukL0hEvJC2",
          "Content-Type": "application/json",
        },
      };
}

export function getAWSImageUrls(){
  return {
    smallImages: "https://d27mku895lz0eb.cloudfront.net/image/320/street/",
    mediumImages: "https://d27mku895lz0eb.cloudfront.net/image/720/street/",
    largeImages: "https://d27mku895lz0eb.cloudfront.net/image/1080/street/",
  }
}